import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { jsx, css } from '@emotion/react';
import vars from '../../../styles/custom-properties.js';

var _excluded = ["children", "scale"];
var getPadding = function getPadding(scale) {
  switch (scale) {
    case 's':
      return "".concat(vars.spacingXs, " ").concat(vars.spacingS);
    case 'm':
      return "".concat(vars.spacingS, " ").concat(vars.spacingM);
    case 'l':
      return "".concat(vars.spacingM, " ").concat(vars.spacingXl);
    default:
      return 0;
  }
};
var InsetSquish = function InsetSquish(_ref) {
  var children = _ref.children,
      scale = _ref.scale,
      props = _objectWithoutProperties(_ref, _excluded);
  return jsx("div", _extends({
    css: css("padding:", getPadding(scale), ";" + ("production" === "production" ? "" : ";label:InsetSquish;"), "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluc2V0LXNxdWlzaC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBY3NFIiwiZmlsZSI6Imluc2V0LXNxdWlzaC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBjdXN0b21Qcm9wZXJ0aWVzIGFzIHZhcnMgfSBmcm9tIFwiLi4vLi4vLi4vc3R5bGVzXCI7XG5jb25zdCBnZXRQYWRkaW5nID0gKHNjYWxlKSA9PiB7XG4gICAgc3dpdGNoIChzY2FsZSkge1xuICAgICAgICBjYXNlICdzJzpcbiAgICAgICAgICAgIHJldHVybiBgJHt2YXJzLnNwYWNpbmdYc30gJHt2YXJzLnNwYWNpbmdTfWA7XG4gICAgICAgIGNhc2UgJ20nOlxuICAgICAgICAgICAgcmV0dXJuIGAke3ZhcnMuc3BhY2luZ1N9ICR7dmFycy5zcGFjaW5nTX1gO1xuICAgICAgICBjYXNlICdsJzpcbiAgICAgICAgICAgIHJldHVybiBgJHt2YXJzLnNwYWNpbmdNfSAke3ZhcnMuc3BhY2luZ1hsfWA7XG4gICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgICByZXR1cm4gMDtcbiAgICB9XG59O1xuY29uc3QgSW5zZXRTcXVpc2ggPSAoeyBjaGlsZHJlbiwgc2NhbGUsIC4uLnByb3BzIH0pID0+ICg8ZGl2IGNzcz17Y3NzIGBcbiAgICAgIHBhZGRpbmc6ICR7Z2V0UGFkZGluZyhzY2FsZSl9O1xuICAgIGB9IHsuLi5wcm9wc30+XG4gICAge2NoaWxkcmVufVxuICA8L2Rpdj4pO1xuSW5zZXRTcXVpc2guZGlzcGxheU5hbWUgPSAnSW5zZXRTcXVpc2gnO1xuSW5zZXRTcXVpc2guZGVmYXVsdFByb3BzID0ge1xuICAgIHNjYWxlOiAnbScsXG59O1xuZXhwb3J0IHsgSW5zZXRTcXVpc2ggfTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPWluc2V0LXNxdWlzaC5qc3gubWFwIl19 */")
  }, props), children);
};
InsetSquish.displayName = 'InsetSquish';
InsetSquish.defaultProps = {
  scale: 'm'
};

export { InsetSquish };
//# sourceMappingURL=inset-squish.js.map
